export var DEPLOY_DATE = new Date('2026-06-03T13:23:05+0000');
